import { Box } from "@material-ui/core";
import ColorPicker from "app/shared/components/ColorPicker";
import React from "react";
import { FormattedMessage } from "react-intl";

const MainColorField = ({ formik }) => {
  return (
    <>
      <Box className="form-label">
        <p className="required">*</p>
        <FormattedMessage id="CLIENT.DASHBOARD.MAIN_COLOR_LABEL" />
      </Box>

      <ColorPicker
        style={mainColorFieldStyle.colorPicker}
        position="right"
        color={formik.values.main_color}
        onChange={(colorValue) =>
          formik.setFieldValue("main_color", colorValue)
        }
      />
    </>
  );
};

export default MainColorField;

const mainColorFieldStyle = {
  colorPicker: {
    borderRadius: "50%",
    height: "30px",
    width: "30px",
    marginLeft: "10px",
  },
};
